import { IconType, MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';
import { v4 as uuidv4 } from 'uuid';
import { IValidationToastNotification } from '../../common';
import { IPriceChangedFields } from '../../utils';

export interface IPriceMismatchWarningProps extends IValidationToastNotification {
  priceChangedFields: IPriceChangedFields[];
}

export const PriceMismatchWarning = (props: IPriceMismatchWarningProps) => {
  const fields = props?.priceChangedFields ?? [];
  return (
    <MessageBar
      severity={TMessageBarSeverity.WARNING}
      dismissible
      onClose={props?.onClose}
      alertIcon={{ icon: IconType.NewNextWarningSolid, size: 32 }}
      className="w-160 border-0 py-8 gap-6 rounded-lg [&_.tw-dismiss-button]:-top-4"
    >
      <h4 className="text-lg/[175%]">Fant prisfeil</h4>
      <ul>
        {fields?.map((price) => (
          <li key={uuidv4()} className="text-base/[175%] font-semibold">
            {`${price?.name ?? ''}:`}{' '}
            <ul>
              <li className="text-base/[175%] font-semibold">Gjeldende pris: {price?.currentPrice ?? 0} Kr</li>
              <li className="text-base/[175%] font-semibold">Ny pris: {price?.newPrice ?? 0} Kr</li>
            </ul>
          </li>
        ))}
      </ul>
    </MessageBar>
  );
};
